import { useId, useState } from 'react'
import { Modal, Button } from '@/components/ui'
import { CreateShiftForm } from './CreateShiftForm'

export interface CreateShiftModalProps {
  companyId: string
  open: boolean
  onClose: () => void
}

export function CreateShiftModal({
  companyId,
  open,
  onClose,
}: CreateShiftModalProps): React.ReactElement {
  const formId = useId()
  const [resetKey, setResetKey] = useState(0)

  if (!open) return <></>

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Create shift"
      className="max-w-2xl"
      footer={
        <>
          <Button type="button" variant="secondary" onClick={() => setResetKey((key) => key + 1)}>
            Reset
          </Button>
          <Button type="button" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button form={formId} type="submit" variant="primary">
            Create
          </Button>
        </>
      }
    >
      <CreateShiftForm
        companyId={companyId}
        onSuccess={onClose}
        externalFormId={formId}
        hideFooter
        resetKey={resetKey}
      />
    </Modal>
  )
}

CreateShiftModal.displayName = 'CreateShiftModal'
